import { ACCORDION_THEMES } from 'common/data/accordion';
import {
  Accordion,
  FormikInput,
  StyledField,
  ToggleSelector,
} from 'components/Common';
import { SelectCountry } from 'components/SelectCountry/SelectCountry';
import { useFormikContext } from 'formik';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Col } from 'reactstrap';

const formFields = [
  {
    type: 'text',
    name: 'deliveryName',
    key: 3.1,
    label: 'client.recipientName',
    placeholder: 'client.recipientNamePlaceholder',
    maxLength: 50,
  },

  {
    type: 'text',
    name: 'addressLineFirst',
    key: 3.2,
    label: 'client.addressLineFirst',
    placeholder: 'client.addressLineFirstPlaceholder',
  },

  {
    type: 'text',
    name: 'city',
    key: 3.3,
    label: 'client.city',
    placeholder: 'client.cityPlaceholder',
  },

  {
    type: 'text',
    name: 'state',
    key: 3.4,
    label: 'client.state',
    placeholder: 'client.statePlaceholder',
  },

  {
    type: 'text',
    name: 'postalCode',
    key: 3.5,
    label: 'client.zipCode',
    placeholder: 'client.zipCodePlaceholder',
    maxLength: 15,
  },
];

export const ApplicantDeliveryForm = ({
  indexApplicant,
  currentApplicant,
  disabled,
}) => {
  const formik = useFormikContext();
  const { t } = useTranslation();

  const mailboxValue = currentApplicant?.address?.mailBox;

  // Mailbox options with translations
  const MAILBOX_OPTIONS = useMemo(
    () => [
      { value: 'yes', label: t('order.yes'), icon: 'bx bx-check-circle' },
      { value: 'no', label: t('order.no'), icon: 'bx bx-x-circle' },
    ],
    [t],
  );

  return (
    <StyledField className="w-100 mt-4 ">
      <Accordion
        title="order.enterAddress"
        theme={ACCORDION_THEMES.SECONDARY}
        icon="bx bx-package"
        defaultOpen
      >
        <div className="d-flex flex-wrap">
          <Col xs={12} className="mt-4">
            <FormikInput
              label="delivery.mailAllowed"
              name="mailBox"
              errors={
                formik.errors.applicants?.[indexApplicant]?.address?.mailBox
              }
              customInput={
                <ToggleSelector
                  options={MAILBOX_OPTIONS}
                  value={mailboxValue}
                  onChange={value => {
                    formik.setFieldValue(
                      `applicants[${indexApplicant}].address.mailBox`,
                      value,
                    );
                  }}
                  disabled={disabled}
                  maxWidth="200px"
                  required={true}
                  theme="secondary" // Matches the accordion theme
                  invalid={
                    !!formik.errors.applicants?.[indexApplicant]?.address
                      ?.mailBox &&
                    formik.touched.applicants?.[indexApplicant]?.address
                      ?.mailBox
                  }
                  errorMessage={t('validation.required')}
                />
              }
            />
          </Col>

          {formFields.map(field => (
            <Col
              key={field.id}
              xs={12}
              // lg={getWeight(index)}
            >
              <FormikInput
                name={`applicants[${indexApplicant}].address.${field.name}`}
                disabled={disabled}
                value={
                  formik.values.applicants?.[indexApplicant]?.address?.[
                    field.name
                  ]
                }
                label={field.label}
                placeholder={field.placeholder}
                handleChange={formik.handleChange}
                errors={
                  formik.errors.applicants?.[indexApplicant]?.address?.[
                    field.name
                  ]
                }
              />
            </Col>
          ))}

          <Col xs={12}>
            <FormikInput
              label="common.country"
              name={`applicants[${indexApplicant}].address.country`}
              errors={
                formik.errors.applicants?.[indexApplicant]?.address?.country
              }
              customInput={
                <SelectCountry
                  isDisabled={disabled}
                  isAvailableDelivery
                  invalid={
                    formik.errors.applicants?.[indexApplicant]?.address?.country
                  }
                  onChange={country =>
                    formik.setFieldValue(
                      `applicants[${indexApplicant}].address.country`,
                      country?.value,
                    )
                  }
                  value={
                    formik.values.applicants?.[indexApplicant]?.address?.country
                  }
                  name="country"
                />
              }
            />
          </Col>
        </div>
      </Accordion>
    </StyledField>
  );
};
